import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const PERFORMERS_GET_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/performers`;

export const PERFORMERS_CREATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/performers/create`;
